import { render, staticRenderFns } from "./pretsRecouvrement.vue?vue&type=template&id=d36f6fbe&"
import script from "./pretsRecouvrement.vue?vue&type=script&lang=js&"
export * from "./pretsRecouvrement.vue?vue&type=script&lang=js&"
import style0 from "./pretsRecouvrement.vue?vue&type=style&index=0&id=d36f6fbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports